<template>
  <el-input
    maxLength="12"
    type="text"
    :size="size"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="changeHandle"
    @input="inputHandle"
    v-model="val"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: undefined,
    disabled: false,
    placeholder: {
      type: String,
      default: '请输入'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      val: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(value) {
        this.val = value
      }
    }
  },
  methods: {
    changeHandle (v) {
      this.val = v.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
      this.$emit('change', this.val ? parseFloat(this.val) : null);
    },
    inputHandle (v) {
      this.val = v.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
      this.$emit('input', this.val ? parseFloat(this.val) : null);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/business/MoneyInput.vue